/* ══════════════════════════════════════════════════════════════════════════
   Shard House — House State Orchestrator
   ══════════════════════════════════════════════════════════════════════════
   Central state manager for the "Enter the House" journey.
   Three stages:  visitor → entered → insider

   - visitor:  no engagement yet (default)
   - entered:  accepted cookies via "Enter the House"
   - insider:  completed release teaser email signup

   Reads/writes localStorage, applies body classes, and dispatches
   a custom event (house:state-change) so any section can react.
   Loaded early in theme.liquid (before cookie-banner.js & teaser.js).
   ══════════════════════════════════════════════════════════════════════════ */

(function () {
    'use strict';

    var STATE_KEY = 'shHouseState';
    var IDENTITY_KEY = 'shHouseIdentity';
    var STAGES = ['visitor', 'entered', 'insider'];

    function stageIndex(stage) {
        var idx = STAGES.indexOf(stage);
        return idx === -1 ? 0 : idx;
    }

    function read() {
        var stored = window.localStorage.getItem(STATE_KEY);
        return STAGES.indexOf(stored) !== -1 ? stored : 'visitor';
    }

    function applyBodyClass(stage) {
        STAGES.forEach(function (s) {
            document.documentElement.classList.remove('sh-house-' + s);
        });
        document.documentElement.classList.add('sh-house-' + stage);
    }

    function advance(newStage) {
        var current = read();
        if (stageIndex(newStage) <= stageIndex(current)) return current;

        window.localStorage.setItem(STATE_KEY, newStage);
        applyBodyClass(newStage);
        window.shHouseState = newStage;

        document.dispatchEvent(new CustomEvent('house:state-change', {
            detail: { previous: current, state: newStage }
        }));

        return newStage;
    }

    /* ── Identity (initials) ── */
    function setIdentity(initials) {
        if (!initials || typeof initials !== 'string') return;
        var clean = initials.replace(/[^A-Za-z]/g, '').slice(0, 3).toUpperCase();
        if (!clean) return;
        window.localStorage.setItem(IDENTITY_KEY, clean);
    }

    function getIdentity() {
        return window.localStorage.getItem(IDENTITY_KEY) || '';
    }

    /* ── Initialise ── */
    var initial = read();
    applyBodyClass(initial);
    window.shHouseState = initial;

    /* Expose a minimal public API */
    window.shHouse = {
        get state() { return read(); },
        advance: advance,
        setIdentity: setIdentity,
        getIdentity: getIdentity
    };
})();
